import React, { useState, useMemo, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { useDebouncedCallback } from "use-debounce";
import {
  Row,
  Col,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import Button from "../Buttons/Button";
import ButtonWithToolTip from "../Buttons/ButtonWithToolTip";
import SearchField from "../searchField/SearchField";
import SelectedCustomerCard from "../customers/SelectedCustomerCard";
import TableCustomHeader from "../table/TableCustomHeader";
import { shopifyActions, transactionActions } from "../../../redux/actions";
import SelectDropDown from "../selectDropdown/SelectDropdown";
import CustomerDropdown from "../selectDropdown/CustomerDropdown";
import ServerPaginationTable from "../agGrid/ServerPaginationTable";
import InfiniteScrollTable from "../agGrid/InfiniteScrollTable";
import { printReceiptData } from "../../Printers/ReceiptPrinters/printReceipt";
import CategoriesDropdown from "../../../shared/components/selectDropdown/CategoriesDropdown";
import PrintLabelModal from "../../../views/Inventory/Items/printingLabelModal/PrintLabelModal";
import { prepareReceiptForPrinter } from "../../Printers/ReceiptPrinters/prepareReceiptForPrinter";
import { viewCartPrintDropdownStyle } from "../../../assets/scss/style/viewCartPrintDropdownStyle";
import SendReceiptModal from "../../../views/SellAndTrade/History/ImportTransactionHistory/SendReceiptModal";
import { prepareReceiptForPrinterTrade } from "../../Printers/ReceiptPrinters/prepareReceiptForPrinterTrade";
import AddNewCustomerModal from "../../../views/SellAndTrade/NewTransaction/AddNewCustomer/AddNewCustomerModal";
import {
  ACTIVITY_TYPES_ENUMS,
  PRODUCT_TYPES_ENUMS,
  TRADING_CARD_CATEGORIES_ENUMS,
} from "../../../system/globalEnums";
import {
  toastType,
  EMPTY_STRING,
  skeletonArray,
  toastMessages,
  globalConstants,
  defaultGridState,
  inventoryConstants,
  buttonNameConstants,
  routesPathConstants,
  buttonTypeConstants,
  transactionConstants,
  categoryDropdownConstants,
  ITEM_HISTORY_DATEPICKER_OPTIONS,
  TABLE_IDS,
} from "../../../constants";
import {
  ShowIcon,
  CrossIcon,
  SearchIcon,
  BlueBoxIcon,
  PrintIcon,
} from "../../../assets/icons/iconsProvider";
import {
  getRowId,
  getRowStyle,
  customToast,
  getTimeFrame,
  getShortestSku,
  calcullateItems,
  parseJsonObject,
  isSpinnerEnabled,
  LoadingIndicator,
  isSaleTransaction,
  isTradeTransaction,
  isReturnTransaction,
  getCustomerFullName,
  getReceiptPrintDate,
  getUnitPurchasePrice,
  parseToDecimalNumber,
  getProductDetailCardTags,
  parseToThousandSeperatorDecimalNumber,
  isButtonDisable,
  createCompanyDynamicUrl,
  getFormattedCondition,
  isShopifyTransaction,
  handleMarkOrderAsOpen,
  handleMarkOrderAsReady,
  handleMarkOrderAsFulfilled,
  getUserNameOnReceipt,
  isShopifyOrderHistory,
  handlePrintShopifyPackingSlips,
  handleTransferToLocation,
  getActionColumnOfAgGridReact,
  getTotalCogsOrSubTotalOfProcessedTransaction,
  getQuantityValue,
  getOutletColumn,
  getTotalQuantityOfTransaction,
  isVoidTransaction,
  getVoidButtonTooltip,
  isVoidDisabled,
  isEmployeeLogin,
  getTotalAmountFromTransaction,
} from "../../utility";
import { success } from "../../../redux/actions/actionsUtilities";
import CustomCellRendererWithSkeleton from "../agGrid/CustomCellRendererWithSkeleton";
import DashboardDatePicker from "../datetimePickerDropdown/DashboardDatePicker";
import { shopifyService } from "../../../services";
import OrderDetailsModal from "../../../views/SellAndTrade/Orders/OrderDetailsModal/OrderDetailsModal";
import { useCompanyStoreFilter } from "../../hooks/useCompanyStoreFilter";
import CompanyStoreDropdown from "../selectDropdown/CompanyStoreDropdown";
import VoidTransactionModal from "./VoidTransactionModal";
import { Ban } from "react-bootstrap-icons";

const TransactionHistoryTableWithFilters = (props) => {
  // initializations
  const {
    user,
    option,
    setOption,
    searchText,
    currentStore,
    spinnerArray,
    allCustomers,
    setSearchText,
    paginationData,
    sendEmailOrSMS,
    sellTradeHistory,
    getAllTransaction,
    isAddCustomerModal,
    emptyAllTransaction,
    defaultReceiptPrinter,
    toggleAddCustomerModal,
    isInfiniteScroll = false,
    updateCustomerInTransactionHistory,
    tableHeight = `calc(100vh - 320px)`,
    isCustomerLogsModal = {
      isSearchField: true,
      customer: { id: EMPTY_STRING },
    },
    datePickerOptions = ITEM_HISTORY_DATEPICKER_OPTIONS,
    updateShopifyOrderStatus,
    currentStoreCompany,
    stores,
    tableId = TABLE_IDS.TRANSACTION_HISTORY,
    updateVoidTransactionHistory,
  } = props;
  const gridRef = useRef();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewCartDetail, setViewCartDetail] = useState([]);
  const [customerToEdit, setCustomerToEdit] = useState({});
  const [isAddCustomer, setIsAddCustomer] = useState(false);
  const [isReceiptModal, setIsReceiptModal] = useState(false);
  const [printRecieptData, setprintRecieptData] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [isShowOrderDetail, setIsShowOrderDetail] = useState(false);
  const [selectedCustomerFlag, setSelectedCustomerFlag] = useState(false);
  const [debouncedSearchText, setDebouncedSearchText] = useState(EMPTY_STRING);
  const [gridState, setGridState] = useState(
    isCustomerLogsModal.customer.id
      ? { ...defaultGridState, searchQuery: isCustomerLogsModal.customer.id }
      : defaultGridState
  );
  const [showVoidModal, setShowVoidModal] = useState(false);
  const [transactionToVoid, setTransactionToVoid] = useState(null);
  const [showVoidDetails, setShowVoidDetails] = useState(false);
  const transaction = viewCartDetail?.[0];

  const handleInitiateVoid = (data, showDetails = false) => {
    if (
      data?.store?.id &&
      currentStore?.id &&
      data.store.id !== currentStore.id
    ) {
      customToast(toastMessages.CANNOT_VOID_DIFFERENT_STORE, toastType.ERROR);
      return;
    }
    setTransactionToVoid(data);
    setShowVoidDetails(showDetails);
    setShowVoidModal(true);
  };
  const hasAccessToVoidTransaction = !isEmployeeLogin(user);
  const [timeFrame, setTimeFrame] = useState({
    start: EMPTY_STRING,
    end: EMPTY_STRING,
    duration: "daily",
  });

  const { selectedStore, setSelectedStore, companyStores, selectedStoreId } =
    useCompanyStoreFilter(currentStoreCompany, currentStore, stores, true);
  const toggleOrderDetailModal = () => {
    setIsShowOrderDetail((prev) => {
      prev && updateGridState(gridState);
      return !prev;
    });
  };
  const handleVoidTransaction = (dataToSend) => {
    let txType = transactionToVoid?.type;
    let endpoint = "transaction";
    if (txType === ACTIVITY_TYPES_ENUMS.TRADE) {
      endpoint = "trade";
    } else {
      txType = ACTIVITY_TYPES_ENUMS.TRANSACTION;
      endpoint = "transaction";
    }

    const transactionDetails = {
      storeId: transactionToVoid?.store?.id,
      id: transactionToVoid?.id,
      type: option?.value || "All",
      start: timeFrame.start,
      end: timeFrame.end,
      companyId: currentStoreCompany?.id,
    };

    updateVoidTransactionHistory(
      dataToSend,
      transactionDetails,
      gridState,
      endpoint
    );

    setTransactionToVoid(null);
  };

  const actionCellRenderer = (params) => (
    <CustomCellRendererWithSkeleton
      params={params}
      cellComponent={
        <div className="d-flex justify-content-center align-items-center">
          <button
            type="button"
            onClick={async () => {
              if (isShopifyOrderHistory(params.data)) {
                const shopifyOrder = await shopifyService.getShopifyOrderById(
                  currentStore?.id,
                  params.data?.shopifyOrderId
                );
                handlePrintShopifyPackingSlips([shopifyOrder], currentStore);
              } else {
                handlePrintReceipt(params.data);
              }
            }}
            className={`action-Button-Wrapper`}
          >
            <PrintIcon className="cursor-pointer text-primary history-view-icon" />
          </button>
          <button
            className="action-Button-Wrapper"
            onClick={() => {
              handleViewCart(params.data);
            }}
          >
            <ShowIcon className="cursor-pointer text-primary history-view-icon" />
          </button>
          {hasAccessToVoidTransaction && (
            <OverlayTrigger
              placement="top"
              overlay={
                getVoidButtonTooltip(params.data) ? (
                  <Tooltip id={`tooltip-void-${params.data.id}`}>
                    {getVoidButtonTooltip(params.data)}
                  </Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <span className="d-inline-block">
                <button
                  className="action-Button-Wrapper"
                  disabled={isVoidDisabled(params.data)}
                  style={{
                    pointerEvents: isVoidDisabled(params.data)
                      ? "none"
                      : "auto",
                    opacity: isVoidDisabled(params.data) ? 0.5 : 1,
                  }}
                  onClick={() => {
                    handleInitiateVoid(params.data, true);
                  }}
                >
                  <Ban
                    color="red"
                    className="cursor-pointer text-primary history-view-icon"
                  />
                </button>
              </span>
            </OverlayTrigger>
          )}
        </div>
      }
      componentRenderCondition={params.data?.id}
    />
  );
  const HistoryColumnsPaginationTable = useMemo(
    () => [
      {
        headerName: "Sale ID",
        field: "id",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`${params.data.id}`}
          />
        ),
      },
      {
        headerName: "Date",
        headerTooltip: "Date",
        field: "createdOn",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            titleToolTipText={getReceiptPrintDate(params.data.createdOn)}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getReceiptPrintDate(params.data.createdOn)}
              </span>
            }
            componentRenderCondition={params?.data?.createdOn}
          />
        ),
      },
      {
        headerName: "Transaction Type",
        headerTooltip: "Transaction Type",
        field: "type",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`${params.data.type}`}
            componentRenderCondition={params?.data?.type}
          />
        ),
      },
      {
        headerName: "Payment",
        headerTooltip: "Payment",
        field: "PaymentType",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              <span className="inventory-cell-max-size ">
                {params?.data?.PaymentType === transactionConstants.CREDIT_CARD
                  ? buttonNameConstants.CREDIT_CARD
                  : params?.data?.PaymentType === transactionConstants.GIFT_CARD
                  ? buttonNameConstants.GIFT_CARD_PAYMENT
                  : params?.data?.PaymentType ===
                    transactionConstants.STORE_CREDIT
                  ? buttonNameConstants.STORE_CREDIT
                  : params?.data?.PaymentType === transactionConstants.OTHER
                  ? buttonNameConstants.OTHER
                  : params?.data?.PaymentType === transactionConstants.SPLIT
                  ? buttonNameConstants.SPLIT
                  : buttonNameConstants.CASH}
              </span>
            }
            componentRenderCondition={params?.data?.PaymentType !== undefined}
          />
        ),
      },
      {
        headerName: "Cart QTY",
        field: "cartQuantity",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              params?.data?.cartQuantity ||
              getTotalQuantityOfTransaction(params?.data)
            }
            componentRenderCondition={params?.data?.inventory}
          />
        ),
      },
      {
        headerName: "Customer",
        field: "customer.name",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getCustomerFullName(params?.data?.customer, true)}
              </span>
            }
            componentRenderCondition={params?.data?.customer}
          />
        ),
      },
      {
        headerName: "Total COGS",
        field: "initialTotalCogs",
        valueGetter: (params) => params?.data?.initialTotalCogs,
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              params?.data?.initialTotalCogs || 0
            )}`}
            componentRenderCondition={
              params?.data?.totalAmountToPay &&
              params.data?.totalAmountToPay !== 0
            }
          />
        ),
      },
      {
        headerName: "Total Amount",
        field: "totalAmount",
        valueGetter: (params) => getTotalAmountFromTransaction(params.data),
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              getTotalAmountFromTransaction(params?.data)
            )}`}
            componentRenderCondition={
              params?.data?.totalAmountToPay ||
              params?.data?.totalAmountToPay === 0
            }
          />
        ),
      },
      getOutletColumn({ currentStore }),
      {
        headerName: "Store",
        field: "store.name",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={params?.data?.store?.name}
          />
        ),
      },
      getActionColumnOfAgGridReact(actionCellRenderer),
    ],
    // eslint-disable-next-line
    [currentStore]
  );
  const HistoryColumnsInfiniteScrollTable = useMemo(
    () => [
      {
        id: "saleId",
        header: "Sale ID",
        accessorKey: "saleId",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`${props?.row?.original?.id}`}
            componentRenderCondition={props?.row?.original?.id}
          />
        ),
        enableSorting: false,
      },
      {
        id: "createdOn",
        header: "Date",
        accessorKey: "createdOn",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size ">
                <TableCustomHeader
                  id={`created-on-in-array-${props?.row?.original?.id}`}
                  label={
                    <span className="inventory-cell-max-size">
                      {getReceiptPrintDate(props?.row?.original?.createdOn)}
                    </span>
                  }
                  toolTipText={
                    <p className="text-start fw-normal m-0">
                      {getReceiptPrintDate(props?.row?.original?.createdOn)}
                    </p>
                  }
                  className="sku-tooltip"
                />
              </span>
            }
            componentRenderCondition={props?.row?.original?.createdOn}
          />
        ),
        enableSorting: false,
      },
      {
        id: "TransactionType",
        header: "Transaction Type",
        accessorKey: "TransactionType",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`${props?.row?.original?.type}`}
            componentRenderCondition={props?.row?.original?.type}
          />
        ),
        enableSorting: false,
      },
      {
        id: "paymentType",
        header: "Payment",
        accessorKey: "paymentType",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size ">
                {props?.row?.original?.PaymentType ===
                transactionConstants.CREDIT_CARD
                  ? buttonNameConstants.CREDIT_CARD
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.GIFT_CARD
                  ? buttonNameConstants.GIFT_CARD_PAYMENT
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.STORE_CREDIT
                  ? buttonNameConstants.STORE_CREDIT
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.OTHER
                  ? buttonNameConstants.OTHER
                  : buttonNameConstants.CASH}
              </span>
            }
            componentRenderCondition={props?.row?.original?.PaymentType}
          />
        ),
        enableSorting: false,
      },
      {
        id: "cartQuantity",
        header: "Cart QTY",
        accessorKey: "cartQuantity",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              props?.row?.original?.inventory?.reduce(
                (a, b) => a + Number(b.quantity),
                0
              ) ||
              props?.row?.original?.inventory?.reduce(
                (a, b) => a + Number(b.price.quantity),
                0
              ) ||
              0
            }
            componentRenderCondition={props?.row?.original?.inventory}
          />
        ),
        enableSorting: false,
      },
      {
        id: "customer",
        header: "Customer",
        accessorKey: "customer",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getCustomerFullName(props?.row?.original?.customer)}
              </span>
            }
            componentRenderCondition={props?.row?.original?.customer}
          />
        ),
        enableSorting: false,
      },
      {
        id: "amount",
        header: "Amount",
        accessorKey: "amount",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              props?.row?.original?.totalAmountToPay
            )}`}
            componentRenderCondition={
              props?.row?.original?.totalAmountToPay ||
              props?.row?.original?.totalAmountToPay === 0
            }
          />
        ),
        enableSorting: false,
      },
      {
        id: "currentBalance",
        header: "Store Credit",
        accessorKey: "currentBalance",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`
              $${parseToThousandSeperatorDecimalNumber(
                props?.row?.original?.customer?.currentBalance
              )}`}
            componentRenderCondition={props?.row?.original?.customer?.id}
          />
        ),
        enableSorting: false,
      },
      {
        id: "id",
        header: EMPTY_STRING,
        accessorKey: "id",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            componentRenderCondition={props?.row?.original?.id}
            cellComponent={
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="action-Button-Wrapper ps-0 pe-0"
                  onClick={() => {
                    handleViewCart(props?.row?.original);
                  }}
                >
                  <ShowIcon className="cursor-pointer text-primary history-view-icon" />
                </button>
                {hasAccessToVoidTransaction && (
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      getVoidButtonTooltip(props?.row?.original) ? (
                        <Tooltip
                          id={`tooltip-void-pg-${props?.row?.original?.id}`}
                        >
                          {getVoidButtonTooltip(props?.row?.original)}
                        </Tooltip>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span className="d-inline-block">
                      <button
                        className="action-Button-Wrapper ps-0 pe-0"
                        disabled={isVoidDisabled(props?.row?.original)}
                        style={{
                          pointerEvents: isVoidDisabled(props?.row?.original)
                            ? "none"
                            : "auto",
                          opacity: isVoidDisabled(props?.row?.original)
                            ? 0.5
                            : 1,
                        }}
                        onClick={() => {
                          handleInitiateVoid(props?.row?.original, true);
                        }}
                      >
                        <Ban
                          color="red"
                          className="cursor-pointer text-primary history-view-icon"
                        />
                      </button>
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            }
          />
        ),
        enableSorting: false,
      },
    ],
    // eslint-disable-next-line
    []
  );

  // helper functions
  const gridData = useMemo(() => {
    let filteredData = sellTradeHistory || [];
    setGridState({
      ...gridState,
      pageIndex: paginationData?.pageNumber || defaultGridState?.pageIndex,
      totalRecords:
        paginationData?.totalRecords || defaultGridState?.totalRecords,
      pageEndRecordNumber:
        paginationData?.pageEndRecordNumber ||
        defaultGridState?.pageEndRecordNumber,
      pageStartRecordNumber:
        paginationData?.pageStartRecordNumber ||
        defaultGridState?.pageStartRecordNumber,
    });
    setIsSearchLoading(false);
    return filteredData;
    // eslint-disable-next-line
  }, [sellTradeHistory]);
  const toggleCustomTradeModal = () => {
    setShow(!show);
    setIsAddCustomer(!isAddCustomer);
  };

  const handleHideModal = () => {
    setShow(!show);
    setViewCartDetail([]);
    setIsAddCustomer(!isAddCustomer);
  };

  const clearSearchText = () => {
    setSearchText("");
    setDebouncedSearchText("");
    updateGridState({ ...gridState, searchQuery: EMPTY_STRING });
  };
  const handleDebouncedSearch = useDebouncedCallback((value) => {
    updateGridState({ ...gridState, searchQuery: value, pageIndex: 1 });
  }, 1000);
  const handleSearchInputChange = (value) => {
    setIsSearchLoading(true);
    handleDebouncedSearch(value);
    setDebouncedSearchText(value);
  };
  const updateGridState = (gridState) => {
    if (!selectedStoreId) {
      return;
    }
    getAllTransaction(
      selectedStoreId,
      option?.value,
      timeFrame.start,
      timeFrame.end,
      gridState,
      EMPTY_STRING
    );
    setGridState(gridState);
  };
  const handleGetTimeFrame = (value) => {
    getTimeFrame(value, timeFrame, setTimeFrame);
  };
  const handlePrintProductLabel = () => {
    toggleCustomTradeModal();
    togglePrintLabelModal();
  };
  const togglePrintLabelModal = () => {
    setPrintLabelModal(!printLabelModal);
    setViewCartDetail([]);
  };
  const selectedCustomer = (selectedCustomerFlag) => {
    setSelectedCustomerFlag(selectedCustomerFlag);
  };
  const handleAddCustomerClick = () => {
    setIsAddCustomer(!isAddCustomer);
  };
  const handleAddNewCustomerClick = () => {
    setCustomerToEdit({});
    toggleAddCustomerModal(true);
  };
  const handleCustomerEditClick = () => {
    const customer = allCustomers?.find(
      (customer) => customer.id === viewCartDetail?.[0]?.customer?.id
    );
    if (customer?.id) {
      setCustomerToEdit(customer);
      toggleAddCustomerModal(true);
    }
  };
  const handleUpdateCustomer = (customer) => {
    const transactionType = isTradeTransaction(viewCartDetail?.[0])
      ? "trade"
      : isSaleTransaction(viewCartDetail?.[0])
      ? "transaction"
      : "return";

    const customerData = customer?.id
      ? customer
      : { name: EMPTY_STRING, id: EMPTY_STRING };
    const { id } = viewCartDetail?.[0] || {};

    if (!selectedStoreId) {
      return;
    }

    const transactionDetails = {
      id,
      selectedStoreId,
      storeId: viewCartDetail?.[0]?.store?.id,
      type: option?.value,
      start: timeFrame.start,
      end: timeFrame.end,
    };

    updateCustomerInTransactionHistory(
      { customer: customerData },
      transactionDetails,
      gridState,
      transactionType
    );
  };
  const handlePrintReceipt = (newTradeData, isGiftReceipt = false) => {
    if (newTradeData.id.substring(0, 3) === globalConstants.TYPE_ID_TRD) {
      handlePrintReceiptTrade(newTradeData, isGiftReceipt);
    } else {
      const printData = prepareReceiptForPrinter(
        newTradeData,
        getUserNameOnReceipt(newTradeData, user),
        newTradeData.id,
        newTradeData.paymentHistory,
        currentStore,
        allCustomers?.find((customer) => {
          if (customer.id === newTradeData?.customer?.id) {
            return {
              ...newTradeData?.customer,
              currentBalance: customer.currentBalance,
            };
          }
          return false;
        }) || {},
        [
          ...newTradeData?.inventory?.map((inv) => {
            return {
              ...inv,
              cogs: inv?.price?.unit_purchase_price,
              item: inv?.product_name,
              priceAfterDiscount: inv?.price?.unit_purchase_price,
              itemName: inv?.product_name,
              quantity: inv?.price?.quantity,
              productType: inv?.productType,
              category: inv?.category_name,
              // max: 2,
              // actualPrice: inv?.price?.unit_sell_price,
              // isDiscountApplied: false,
              // discountPercentage: 0,
              // priceAfterDiscount: 1000,
              // actualDiscountPercentage: 0,
            };
          }),
        ],
        newTradeData.discount,
        newTradeData.SubTotal,
        newTradeData.Tax,
        newTradeData.totalAmountToPay,
        newTradeData.cashTenderedAmount,
        newTradeData.cashChangeOwed,
        newTradeData.giftCardPaymentHistory,
        false,
        isGiftReceipt,
        newTradeData.discountMethod,
        newTradeData.discountedValue,
        getReceiptPrintDate(newTradeData.createdOn),
        { isReprint: true }
      );
      printReceiptData(printData, defaultReceiptPrinter);
    }
  };
  const handlePrintReceiptTrade = (newTradeData, isGiftReceipt = false) => {
    const partialPayment =
      (newTradeData?.paymentHistory?.[transactionConstants.CASH] || 0) +
        (newTradeData?.paymentHistory?.[transactionConstants.STORE_CREDIT] ||
          0) >
        0 &&
      newTradeData?.totalAmountToPay !== newTradeData?.currentAmountToPay;
    const printData = prepareReceiptForPrinterTrade(
      getUserNameOnReceipt(newTradeData, user),
      newTradeData?.id,
      newTradeData?.paymentHistory,
      currentStore,
      allCustomers?.find((customer) => {
        if (customer.id === newTradeData?.customer?.id) {
          return {
            ...newTradeData?.customer,
            currentBalance: customer.currentBalance,
          };
        }
        return false;
      }) || {},
      [
        ...newTradeData?.inventory.map((inv) => {
          return {
            ...inv,
            cogs: inv?.price?.unit_purchase_price,
            item: inv?.product_name,
            priceAfterDiscount: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
            itemName: inv?.product_name,
            quantity: inv?.price?.quantity,
            productType: inv?.productType,
            category: inv?.category_name,
            actualPrice: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
            // max: 2,
            // actualPrice: inv?.price?.unit_sell_price,
            // isDiscountApplied: false,
            // discountPercentage: 0,
            // priceAfterDiscount: 1000,
            // actualDiscountPercentage: 0,
          };
        }),
      ],
      newTradeData?.discount,
      newTradeData?.SubTotal,
      newTradeData?.Tax,
      newTradeData?.totalAmountToPay,
      0,
      0,
      false,
      partialPayment,
      isGiftReceipt,
      getReceiptPrintDate(newTradeData.createdOn),
      { isReprint: true }
    );
    printReceiptData(printData, defaultReceiptPrinter);
  };
  const toggleIsReceiptModal = () => {
    setIsReceiptModal(!isReceiptModal);
  };
  const handleIssueRefund = () => {
    navigate(
      createCompanyDynamicUrl(routesPathConstants.SELL_AND_TRADE_NEW_RETURN),
      {
        state: {
          id: viewCartDetail?.[0]?.id,
        },
      }
    );
  };
  const handleViewCart = async (row) => {
    setprintRecieptData(row);
    setViewCartDetail([row]);
    setSelectedRows([]);

    if (isShopifyOrderHistory(row)) {
      const shopifyOrder = await shopifyService.getShopifyOrderById(
        currentStore?.id,
        row?.shopifyOrderId
      );
      setViewCartDetail([shopifyOrder]);
      toggleOrderDetailModal();
      return;
    }

    setSelectedRows(
      row?.inventory.map((item) => {
        const newObject = {
          sku: getShortestSku(item.sku),
          product_name: item.product_name,
          productType: item.productType,
          price: {
            quantity: item?.price?.quantity,
            type: item?.price?.type,
            unit_sell_price: isTradeTransaction(row)
              ? item?.price?.unit_sell_price
              : item?.price?.unit_purchase_price,
          },
          category_name: item?.category_name || item?.category,
          tags: item?.tags,
        };
        return newObject;
      })
    );
    toggleCustomTradeModal();
  };
  const fetchMoreData = () => {
    updateGridState({
      ...gridState,
      pageSize:
        Number(
          gridState?.pageSize ?? inventoryConstants.ITEM_HISTORY_LIST_LENGTH
        ) + Number(inventoryConstants.ITEM_HISTORY_LIST_LENGTH),
    });
  };

  // useEffects
  useEffect(() => {
    if (
      selectedStoreId &&
      selectedStore?.value &&
      timeFrame.start &&
      timeFrame.end
    ) {
      /*
        If "All Stores" is selected in the dropdown, pass the comma-separated store ids explicitly.
        Otherwise, pass the selected store id from the dropdown.
        For dummy companies store with no company, always use the current store id.
      */
      getAllTransaction(
        selectedStoreId,
        option?.value,
        timeFrame.start,
        timeFrame.end,
        gridState,
        EMPTY_STRING
      );
    }

    return () => {
      emptyAllTransaction();
    };
  }, [timeFrame.start, timeFrame.end, option, selectedStoreId]);
  useEffect(() => {
    if (allCustomers && allCustomers.length > 0 && selectedCustomerFlag) {
      handleUpdateCustomer({
        ...allCustomers[0],
        name: allCustomers[0].firstName + " " + allCustomers[0].lastName,
      });
    }
    setSelectedCustomerFlag(false);
    // eslint-disable-next-line
  }, [allCustomers]);
  useEffect(() => {
    if (viewCartDetail?.[0]?.id) {
      setViewCartDetail(
        sellTradeHistory?.filter((item) => item.id === viewCartDetail?.[0]?.id)
      );
    }
    // eslint-disable-next-line
  }, [sellTradeHistory]);
  useEffect(() => {
    setAddCustomerModal(isAddCustomerModal);
    // eslint-disable-next-line
  }, [isAddCustomerModal]);

  return (
    <>
      <Row className="m-0">
        <Col md={12} className="d-flex align-items-center mb-2 gap-3">
          <div className={`w-100 d-flex align-items-center gap-3 `}>
            <DashboardDatePicker
              label="Date"
              getTimeFrame={handleGetTimeFrame}
              datePickerOptions={datePickerOptions}
            />
            <CompanyStoreDropdown
              currentStoreCompany={currentStoreCompany}
              companyStores={companyStores}
              selectedStore={selectedStore}
              setSelectedStore={setSelectedStore}
              className="dropdown-max-width"
            />
            <CategoriesDropdown
              label="Type"
              options={inventoryConstants.TRANSACTION_TYPE}
              handleChange={(e) => {
                setOption(
                  e == null
                    ? {
                        label: globalConstants.ALL,
                        value: globalConstants.ALL,
                      }
                    : e
                );
              }}
              noOptionsMessage="No Transaction Type Found"
              placeholder="Transaction Type"
              SelectIconImage={categoryDropdownConstants.TRANSACTION_ICON}
              className={"dropdown-max-width"}
              isClearable={false}
              defaultValue={{
                value: PRODUCT_TYPES_ENUMS.ALL,
                label: "All",
              }}
            />
            {isCustomerLogsModal.isSearchField && (
              <SearchField
                onChange={(e) => handleSearchInputChange(e.target.value)}
                IconImage={SearchIcon}
                BlueBoxIcon={BlueBoxIcon}
                label="Search"
                placeHolder="Type or Scan"
                value={debouncedSearchText}
                CrossIcon={debouncedSearchText ? CrossIcon : ""}
                clearSearchText={clearSearchText}
                LoadingIndicator={
                  isSearchLoading ||
                  (isButtonDisable(
                    spinnerArray,
                    transactionConstants.GET_ALL_TRANSACTION
                  ) &&
                    searchText)
                    ? LoadingIndicator
                    : false
                }
              />
            )}
          </div>
        </Col>
      </Row>
      <Row
        className={`m-0 w-100 h-100 user-screen-wrapper pt-3 p-0 ${
          isInfiniteScroll && isCustomerLogsModal.customer.id
            ? EMPTY_STRING
            : "pb-5 mb-2"
        }`}
      >
        {isInfiniteScroll ? (
          <InfiniteScrollTable
            columns={HistoryColumnsInfiniteScrollTable}
            data={gridData}
            update={fetchMoreData}
            tableId={tableId}
            hasMore={gridState?.pageSize < gridState?.totalRecords}
            isLoading={isSpinnerEnabled(
              spinnerArray,
              transactionConstants.GET_ALL_TRANSACTION
            )}
          />
        ) : (
          <ServerPaginationTable
            colDefs={HistoryColumnsPaginationTable}
            gridRef={gridRef}
            gridData={
              isSpinnerEnabled(
                spinnerArray,
                transactionConstants.GET_ALL_TRANSACTION
              )
                ? skeletonArray
                : gridData
            }
            gridState={gridState}
            getRowId={getRowId}
            singleClickEdit={false}
            getRowStyle={getRowStyle}
            updateGridState={updateGridState}
            paginationPageSize={gridState.pageSize}
            pageSizeOptions={gridState.pageSizeOptions}
            isDisablePaginationActions={isSpinnerEnabled(
              spinnerArray,
              transactionConstants.GET_ALL_TRANSACTION
            )}
            tableHeight={tableHeight}
            tableId={tableId}
          />
        )}
      </Row>
      <Modal
        show={show}
        onHide={handleHideModal}
        size={`${hasAccessToVoidTransaction ? "lg" : "md"}`}
        animation={true}
        centered
        backdrop="static"
        className="add-inventory-modal"
      >
        <Form className="px-0">
          <Modal.Header closeButton>
            <Modal.Title className="d-flex flex-column">
              <span className="modal-sale-transaction-id d-flex align-items-center">
                {isTradeTransaction(viewCartDetail?.[0])
                  ? "Trade "
                  : isReturnTransaction(viewCartDetail?.[0])
                  ? "Return "
                  : "Sale "}
                ({viewCartDetail?.[0]?.id})
              </span>
              {transaction?.isVoided && transaction?.voidedAt && (
                <span className="text-danger fw-bold fs-6 mt-1">
                  (VOIDED - {new Date(transaction.voidedAt).toLocaleString()})
                </span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-0">
            <Row className="my-2">
              {isVoidTransaction(transaction) && (
                <div className="d-flex gap-1">
                  <span className="fw-bold fs-6 mt-1">Voided by:</span>
                  <span className="fs-6 mt-1">{transaction.voidedBy.name}</span>
                </div>
              )}

              {isVoidTransaction(transaction) && transaction.voidReason && (
                <div className="d-flex gap-1">
                  <span className="fw-bold fs-6 mt-1">Voided reason:</span>
                  <span className="fs-6 mt-1">{transaction.voidReason}</span>
                </div>
              )}
              {transaction?.isVoidTransaction && transaction?.voidReason && (
                <div className="d-flex gap-1">
                  <span className="fw-bold fs-6 mt-1">
                    Original Transaction ID:
                  </span>
                  <span className="fs-6 mt-1">
                    {transaction.originalTransactionId}
                  </span>
                </div>
              )}
            </Row>
            <Row className="m-0 p-0">
              <Col md={12} className="p-0 mb-2">
                <span className="trans-items-modal view-cart-date">
                  {getReceiptPrintDate(viewCartDetail?.[0]?.createdOn)}
                </span>
              </Col>
              <Col md={12} className="p-0 mb-4 mt-2">
                {Array.isArray(viewCartDetail) &&
                viewCartDetail?.[0]?.customer?.id ? (
                  <SelectedCustomerCard
                    customer={viewCartDetail?.[0]?.customer}
                    isDeleteEditOptions={true}
                    isStoreCredit={false}
                    handleCustomerDeleteClick={() => {
                      if (
                        viewCartDetail?.[0]?.paymentHistory?.totalPaidAmount
                          ?.storeCredit > 0
                      ) {
                        customToast(
                          toastMessages.UPDATE_CUSTOMER_ERROR,
                          toastType.ERROR
                        );
                      } else {
                        handleUpdateCustomer(false);
                      }
                    }}
                    handleCustomerEditClick={handleCustomerEditClick}
                    className={{
                      parnetDiv: "selected-customer-wrapper gap-3",
                      nameDiv: "selected-customer-wrapper",
                      nameSpan: "trans-product-name-modal-total",
                      editDeleteDiv: "ms-auto",
                      deleteButton: "p-0 opacity-50",
                      editButton: "p-0 opacity-50",
                    }}
                    isShopifyTransaction={isShopifyTransaction(
                      viewCartDetail?.[0]?.id
                    )}
                  />
                ) : !isAddCustomer ? (
                  <Button
                    className="p-0"
                    type="button"
                    label={buttonNameConstants.ADD_CUSTOMER}
                    buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                    handleClick={handleAddCustomerClick}
                  />
                ) : (
                  <CustomerDropdown
                    value={""}
                    menuPortalTarget=""
                    dropdownIndicator={false}
                    noOptionsMessage="No Customer Found"
                    placeholder="Customer Name, Phone, Email"
                    handleAddCustomerClick={handleAddNewCustomerClick}
                    SelectIconImage={categoryDropdownConstants.SEARCH_ICON}
                    handleChange={(selectedOption) => {
                      if (selectedOption?.value) {
                        handleUpdateCustomer(
                          parseJsonObject(selectedOption?.value)
                        );
                      }
                    }}
                    selectedCustomerFlag={selectedCustomerFlag}
                  />
                )}
              </Col>
            </Row>
            <Row className="m-0 p-0 ">
              <div className="container-scrollbar p-0  trans-modal-card-wrapper ">
                <Row className="m-0">
                  <Col
                    sm={6}
                    className="px-0 d-flex align-items-center mb-3 history-cart-table-header"
                  >
                    Product Name
                  </Col>
                  <Col
                    sm={3}
                    className="px-0 d-flex align-items-center justify-content-end mb-3 history-cart-table-header"
                  >
                    {isTradeTransaction(viewCartDetail?.[0])
                      ? "Stock Price"
                      : "COGS"}
                  </Col>
                  <Col
                    sm={3}
                    className="px-0 d-flex align-items-center justify-content-end mb-3 pe-1 history-cart-table-header"
                  >
                    {isTradeTransaction(viewCartDetail?.[0])
                      ? "COGS"
                      : "Stock Price"}
                  </Col>
                  {Array.isArray(viewCartDetail) &&
                    viewCartDetail?.[0]?.inventory?.map((product) => {
                      return (
                        <>
                          <Col
                            sm={6}
                            className="px-0 d-flex align-items-center"
                          >
                            <div className="d-flex align-items-center gap-1">
                              <span className="trans-items-modal">
                                {getQuantityValue(product, true, true)}
                              </span>
                              <span className="trans-product-name-modal">
                                {product.product_name}
                              </span>
                              <span className="trans-items-modal">
                                {product?.sku !==
                                  transactionConstants.QUICK_TRADE &&
                                  `#${getShortestSku(product?.sku)}`}
                              </span>
                            </div>
                          </Col>
                          <Col
                            sm={3}
                            className="px-0 d-flex align-items-center justify-content-end"
                          >
                            <div>
                              <span className="trans-product-name-modal">
                                $
                                {isTradeTransaction(viewCartDetail?.[0])
                                  ? parseToThousandSeperatorDecimalNumber(
                                      product?.price?.unit_sell_price
                                    )
                                  : parseToThousandSeperatorDecimalNumber(
                                      product?.cogs
                                    )}
                              </span>
                            </div>
                          </Col>
                          <Col
                            sm={3}
                            className="px-0 d-flex align-items-center justify-content-end"
                          >
                            <div>
                              <span className="trans-product-name-modal">
                                $
                                {isTradeTransaction(viewCartDetail?.[0])
                                  ? parseToThousandSeperatorDecimalNumber(
                                      product?.price?.unit_purchase_price
                                    )
                                  : parseToThousandSeperatorDecimalNumber(
                                      product?.price?.unit_purchase_price
                                    )}
                              </span>
                            </div>
                          </Col>
                          <Col
                            md={12}
                            className={`m-0 p-0
                             d-flex justify-content-between ${
                               product?.discountPercentage > 0
                                 ? EMPTY_STRING
                                 : "mb-3"
                             }`}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <span className="trans-items-modal ms-3">
                                {isTradeTransaction(viewCartDetail?.[0])
                                  ? product?.["category_name"]
                                  : product?.category}
                              </span>
                              <span className="trans-items-modal">
                                ({getFormattedCondition(product)})
                              </span>
                              {
                                // Show serial number for systems/consoles if found
                                product?.subcategory ===
                                  TRADING_CARD_CATEGORIES_ENUMS.SYSTEM &&
                                  product?.serialNumber && (
                                    <span className="trans-items-modal">
                                      S/N : {product?.serialNumber}
                                    </span>
                                  )
                              }
                              <span className="trans-items-modal">
                                {getProductDetailCardTags(
                                  product.tags?.filter(
                                    (tag) =>
                                      tag !== inventoryConstants.CUSTOM_ITEM_TAG
                                  ),
                                  product.sku
                                )}
                              </span>
                            </div>
                          </Col>
                          {Number(product?.discountPercentage) > 0 && (
                            <>
                              <Col
                                sm={6}
                                className="px-0 d-flex align-items-center mb-3"
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <span className="trans-product-name-modal ps-5">
                                    {`Discount(${
                                      product.isToggleDiscount
                                        ? `$${product.discountPercentage}`
                                        : `${product.discountPercentage}%`
                                    })`}
                                  </span>
                                </div>
                              </Col>
                              <Col
                                sm={6}
                                className="px-0 d-flex align-items-center justify-content-end mb-3"
                              >
                                <div>
                                  <span className="trans-product-name-modal">
                                    - $
                                    {parseToThousandSeperatorDecimalNumber(
                                      product.isToggleDiscount
                                        ? parseToThousandSeperatorDecimalNumber(
                                            product.discountPercentage
                                          )
                                        : parseToThousandSeperatorDecimalNumber(
                                            (Number(product.actualPrice) *
                                              Number(
                                                product.discountPercentage
                                              )) /
                                              100
                                          )
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </>
                          )}
                        </>
                      );
                    })}
                </Row>
              </div>
              <Col
                md={12}
                className="m-0 mt-2 mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
              >
                <div className="trans-product-name-modal-text m-0">
                  Subtotal
                </div>

                <div className="">
                  {` $${getTotalCogsOrSubTotalOfProcessedTransaction(
                    viewCartDetail?.[0],
                    true,
                    true
                  )}`}
                </div>
              </Col>
              <>
                {
                  // discount is visible in case of sale transaction
                  isSaleTransaction(viewCartDetail?.[0]) && (
                    <Col
                      md={12}
                      className="m-0  mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
                    >
                      <div className="trans-product-name-modal-text m-0">
                        Discount
                      </div>
                      <div className="">
                        {`$${parseToThousandSeperatorDecimalNumber(
                          viewCartDetail?.[0]?.discount
                        )}`}
                      </div>
                    </Col>
                  )
                }
                {
                  // tax is visible in case of sale and return transaction
                  (isSaleTransaction(viewCartDetail?.[0]) ||
                    isReturnTransaction(viewCartDetail?.[0])) && (
                    <Col
                      md={12}
                      className="m-0  mb-2 p-0 d-flex justify-content-between tran-modal-detail-margin"
                    >
                      <div className="trans-product-name-modal-text m-0">
                        {`Tax(
                  ${parseToDecimalNumber(
                    viewCartDetail?.[0]?.taxPercentage ?? 0
                  )}
                  %)`}
                      </div>
                      <div className="">
                        {`$${parseToThousandSeperatorDecimalNumber(
                          viewCartDetail?.[0]?.Tax ?? 0
                        )}`}
                      </div>
                    </Col>
                  )
                }
              </>

              <Col
                md={12}
                className="m-0  mb-2 p-0 pt-2 d-flex justify-content-between border-top tran-modal-detail-margin"
              >
                <div className="trans-product-name-modal-total m-0">
                  TOTAL ({calcullateItems(viewCartDetail?.[0]?.inventory)}{" "}
                  items)
                </div>

                <div className="trans-product-name-modal-total">
                  $
                  {parseToThousandSeperatorDecimalNumber(
                    isTradeTransaction(viewCartDetail?.[0])
                      ? viewCartDetail?.[0]?.initialTotalCogs
                      : viewCartDetail?.[0]?.totalAmountToPay
                  )}
                </div>
              </Col>
              {
                // PAYMENT HISTORY: history is generating in case of transaction (sale) and trade and in case of return use the current paid values as there is no split payment feature in return transaction
                isReturnTransaction(viewCartDetail?.[0]) ? (
                  <Col
                    md={12}
                    className="m-0 p-0 mb-1 d-flex justify-content-between"
                  >
                    <div className="d-flex align-items-center gap-1">
                      <span className="trans-product-name-modal-text">
                        {viewCartDetail?.[0].PaymentType ===
                        transactionConstants.CREDIT_CARD
                          ? buttonNameConstants.CREDIT_CARD
                          : viewCartDetail?.[0].PaymentType ===
                            transactionConstants.STORE_CREDIT
                          ? buttonNameConstants.STORE_CREDIT
                          : viewCartDetail?.[0].PaymentType ===
                            transactionConstants.GIFT_CARD
                          ? viewCartDetail?.[0]?.giftCard?.giftCardName
                          : viewCartDetail?.[0].PaymentType ===
                            transactionConstants.OTHER
                          ? buttonNameConstants.OTHER
                          : buttonNameConstants.CASH}
                      </span>
                    </div>
                    <div>
                      <span className="trans-product-name-modal-text">
                        $
                        {parseToThousandSeperatorDecimalNumber(
                          viewCartDetail?.[0]?.totalAmountToPay
                        )}
                      </span>
                    </div>
                  </Col>
                ) : (
                  viewCartDetail?.[0]?.paymentHistory?.history?.map(
                    (history) => {
                      return history.isUndoTransaction ? (
                        <Col
                          md={12}
                          className="m-0 p-0 mb-1 d-flex justify-content-between"
                        >
                          <div className="d-flex align-items-center gap-1">
                            <span className="trans-product-name-modal-text">
                              {history.paymentType ===
                              transactionConstants.CREDIT_CARD
                                ? buttonNameConstants.CREDIT_CARD
                                : history.paymentType ===
                                  transactionConstants.STORE_CREDIT
                                ? buttonNameConstants.STORE_CREDIT
                                : history.paymentType ===
                                  transactionConstants.GIFT_CARD
                                ? history?.giftCardName
                                : history.paymentType ===
                                  transactionConstants.OTHER
                                ? buttonNameConstants.OTHER
                                : buttonNameConstants.CASH}
                            </span>
                          </div>
                          <div>
                            <span className="trans-product-name-modal-text">
                              $
                              {parseToThousandSeperatorDecimalNumber(
                                history?.currentAmountToPay
                              )}
                            </span>
                          </div>
                        </Col>
                      ) : (
                        ""
                      );
                    }
                  )
                )
              }
            </Row>
            {viewCartDetail?.[0]?.note && (
              <Col md={12} className="m-0 mt-3   p-0">
                <div className="note-text-div container-scrollbar">
                  <p className="trans-items-modal mb-2">Note</p>
                  <span className="note-text">{viewCartDetail?.[0]?.note}</span>
                </div>
              </Col>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center gap-2 w-100">
              <Button
                type="button"
                label={buttonNameConstants.CLOSE}
                handleClick={() => handleHideModal()}
                buttonType={buttonTypeConstants.GHOST_BUTTON}
                className="w-100"
              />
              <SelectDropDown
                outerWrapperClassname="w-100"
                menuPortalTarget=""
                isSingleValue="Receipt"
                placeHolder="Receipt"
                handleChange={(option) => {
                  if (
                    option?.value === transactionConstants.RECEIPT_OPTION.PRINT
                  ) {
                    handlePrintReceipt(printRecieptData);
                  } else if (
                    option?.value ===
                    transactionConstants.RECEIPT_OPTION.GIFT_RECEIPT
                  ) {
                    handlePrintReceipt(printRecieptData, true);
                  } else if (
                    option?.value === transactionConstants.RECEIPT_OPTION.SEND
                  ) {
                    toggleIsReceiptModal();
                  }
                }}
                styles={viewCartPrintDropdownStyle}
                menuPlacement="bottom"
                options={transactionConstants.RECEIPT_OPTIONS}
              />

              {viewCartDetail?.[0]?.id.substring(0, 3) ===
              globalConstants.TYPE_ID_TRA ? (
                <Button
                  type="button"
                  className="w-100"
                  isDisabled={
                    isShopifyTransaction(viewCartDetail?.[0]?.id) ||
                    isVoidTransaction(viewCartDetail?.[0])
                  }
                  label={buttonNameConstants.ISSUE_REFUND}
                  handleClick={handleIssueRefund}
                />
              ) : viewCartDetail?.[0]?.id.substring(0, 3) ===
                globalConstants.TYPE_ID_TRD ? (
                <Button
                  type="button"
                  className="w-100"
                  label={buttonNameConstants.PRINT_PRODUCT_LABEL}
                  handleClick={handlePrintProductLabel}
                ></Button>
              ) : (
                ""
              )}
              {hasAccessToVoidTransaction &&
                viewCartDetail?.[0]?.type !== ACTIVITY_TYPES_ENUMS.RETURN && (
                  <ButtonWithToolTip
                    type="button"
                    toolTipRootClassName="w-100"
                    className="w-100"
                    toolTipBody={getVoidButtonTooltip(viewCartDetail?.[0])}
                    placement="top"
                    isDisabled={isVoidDisabled(viewCartDetail?.[0])}
                    style={{
                      pointerEvents: isVoidDisabled(viewCartDetail?.[0])
                        ? "none"
                        : "auto",
                    }}
                    label={buttonNameConstants.VOID_TRANSACTION}
                    handleClick={() => handleInitiateVoid(viewCartDetail?.[0])}
                  />
                )}
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
      <PrintLabelModal
        printLabelModal={printLabelModal}
        togglePrintLabelModal={togglePrintLabelModal}
        selectedRows={selectedRows}
      />
      <SendReceiptModal
        sendEmailOrSMS={sendEmailOrSMS}
        transactionData={viewCartDetail?.[0]}
        isReceiptModal={isReceiptModal}
        toggleIsReceiptModal={toggleIsReceiptModal}
      />
      {/* as order detail has it's own addCustomerModal */}
      {isShowOrderDetail ? (
        <OrderDetailsModal
          orderDetail={viewCartDetail?.[0]}
          currentStore={currentStore}
          defaultGridState={gridState}
          shopifyOrdersCallBackConfig={{
            orderDetail: viewCartDetail?.[0],
            gridState: gridState,
            isRefetchTransactionsOnSave: true,
            callBackFuction: (updatedOrder) => {
              if (updatedOrder) setViewCartDetail([updatedOrder]);
            },
          }}
          isShowOrderDetail={isShowOrderDetail}
          handleMarkOrderAsOpen={handleMarkOrderAsOpen}
          toggleOrderDetailModal={toggleOrderDetailModal}
          handleMarkOrderAsReady={handleMarkOrderAsReady}
          updateShopifyOrderStatus={updateShopifyOrderStatus}
          handleMarkOrderAsFulfilled={handleMarkOrderAsFulfilled}
          handleTransferToLocation={handleTransferToLocation}
        />
      ) : (
        <AddNewCustomerModal
          selectedCustomer={selectedCustomer}
          addCustomerModal={addCustomerModal}
          customerToEdit={customerToEdit}
        />
      )}
      <VoidTransactionModal
        show={showVoidModal}
        onHide={() => {
          setShowVoidModal(false);
          setTransactionToVoid(null);
        }}
        transaction={transactionToVoid}
        user={user}
        showDetails={showVoidDetails}
        onSubmitVoid={handleVoidTransaction}
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  user: state.authentication.user,
  currentStore: state.store.currentStore,
  stores: state.store.stores,
  currentStoreCompany: state.company.currentStoreCompany,
  spinnerArray: state.system.spinnerArray,
  allCustomers: state.customer.allCustomers,
  allTransaction: state.transaction.allTransaction,
  paginationData: state.transaction.allTransaction.paginationData,
  sellTradeHistory: state.transaction.allTransaction.sellTradeHistory,
  isAddCustomerModal: state.transaction.isAddCustomerModal,
  defaultReceiptPrinter: state.printer.defaultReceiptPrinter,
  duplicateHistoryRecords: state.transaction.duplicateHistoryRecords,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getAllTransaction: (storeId, type, start, end, gridState, companyId) =>
    dispatch(
      transactionActions.getAllTransaction(
        storeId,
        type,
        start,
        end,
        gridState,
        companyId
      )
    ),
  emptyAllTransaction: () =>
    dispatch(success({}, transactionConstants.GET_ALL_TRANSACTION)),
  sendEmailOrSMS: (data) => dispatch(transactionActions.sendEmailOrSMS(data)),
  updateCustomerInTransactionHistory: (
    data,
    transactionDetails,
    gridState,
    endPoint
  ) =>
    dispatch(
      transactionActions.updateCustomerInTransactionHistory(
        data,
        transactionDetails,
        gridState,
        endPoint
      )
    ),
  toggleAddCustomerModal: (value) =>
    dispatch(transactionActions.toggleAddCustomerModal(value)),
  getShopifyOrderById: (storeId, orderId) =>
    dispatch(shopifyActions.getShopifyOrderById(storeId, orderId)),
  updateShopifyOrderStatus: (
    storeId,
    data,
    gridState,
    toggleOrderDetailsModal
  ) =>
    dispatch(
      shopifyActions.updateShopifyOrderStatus(
        storeId,
        data,
        gridState,
        toggleOrderDetailsModal
      )
    ),
  updateVoidTransactionHistory: (
    data,
    transactionDetails,
    gridState,
    endpoint
  ) =>
    dispatch(
      transactionActions.updateVoidTransactionHistory(
        data,
        transactionDetails,
        gridState,
        endpoint
      )
    ),
});

//-------Export History Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionHistoryTableWithFilters);
